export const SET_CARDS = 'SET_CARDS';
/** Every card of every set, for the card lookup (loaded only there). */
export const SET_ALL_CARDS = 'SET_ALL_CARDS';
export const GET_ALL_CARDS = 'GET_ALL_CARDS';
/** Loads the playable cards if they aren't yet (a page that shows cards outside a game). */
export const ENSURE_CARDS = 'ENSURE_CARDS';
